<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div style="display: flex;justify-content: space-between">
      <text-title :mainTitle="'园区平台服务配置'" />
      <div class="operationBox">
        <a @click="changeyqServiceState" v-if="yqServiceState && (permissionCodes.indexOf('010001001') !== -1) ">修改</a><a @click="cancelChangeyqServiceState" v-if="!yqServiceState">取消</a><a @click="confirmChangeyqServiceState" v-if="!yqServiceState">确定</a>
      </div>
    </div>
    <p style="display: flex;justify-content: flex-start;flex-wrap: wrap;">
      <span class="server_box" v-for="(item, index) in serviceList" :key="index">
        <span>{{item.name}}</span>
        <el-select v-model="item.servicesState" placeholder="请选择" size="mini" :disabled="yqServiceState" class="server_change" >
          <el-option
            v-for="item in serverStateList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          :disabled="yqServiceState"
          v-if="item.servicesState !== '0' "
          v-model="item.servicesTime"
          :clearable="false"
          class="server_time"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </span>
    </p>

    <!--<div style="display: flex;justify-content: space-between">-->
      <!--<text-title :mainTitle="'园区码小程序功能配置'" />-->
      <!--<div class="operationBox">-->
        <!--<a @click="changeSchoolCodeState" v-if="yqCodeState && (permissionCodes.indexOf('010001002') !== -1)">修改</a><a @click="cancelChangeSchoolCodeState" v-if="!yqCodeState">取消</a><a @click="confirmChangeSchoolCodeState" v-if="!yqCodeState">确定</a>-->
      <!--</div>-->
    <!--</div>-->
    <!--<p>-->
      <!--<el-checkbox-group v-model="checkList">-->
        <!--<div>-->
          <!--<el-checkbox label="智慧门禁" :disabled="yqCodeState" />-->
          <!--<el-checkbox label="访客预约" :disabled="yqCodeState" />-->
          <!--<el-checkbox label="智慧预约" :disabled="yqCodeState" />-->
          <!--<el-checkbox label="停车缴费" :disabled="yqCodeState" />-->
        <!--</div>-->
        <!--<div>-->
          <!--<el-checkbox label="录入人脸" :disabled="yqCodeState" />-->
          <!--<el-checkbox label="推荐有礼" :disabled="yqCodeState" />-->
          <!--<el-checkbox label="使用帮助" :disabled="yqCodeState" />-->
          <!--<el-checkbox label="更多" :disabled="yqCodeState" />-->
        <!--</div>-->
      <!--</el-checkbox-group>-->
    <!--</p>-->


    <div style="display: flex;justify-content: space-between">
      <text-title :mainTitle="'人脸设备参数配置'" />
      <div class="operationBox">
        <a @click="changeFaceDataConfig" v-if="faceDataConfig">修改</a><a @click="cancelChangeFaceDataConfig" v-if="!faceDataConfig">取消</a><a @click="confirmChangeFaceDataConfig" v-if="!faceDataConfig">确定</a>
      </div>
    </div>
    <p class="faceConfig">
      <span style="display: inline-block;width: 84px;text-align: right">appId</span>
      <el-input v-model="faceConfigList.appId" :disabled="faceDataConfig" placeholder="请输入appId" size="mini" style="width: 280px;margin-left: 5px;" />
    </p>
    <p class="faceConfig">
      <span style="display: inline-block;width: 84px;text-align: right">appKey</span>
      <el-input v-model="faceConfigList.appKey" :disabled="faceDataConfig" placeholder="请输入appKey" size="mini" style="width: 280px;margin-left: 5px;" />
    </p>
    <p class="faceConfig">
      <span style="display: inline-block;width: 84px;text-align: right">appSecret</span>
      <el-input v-model="faceConfigList.appSecret" :disabled="faceDataConfig" placeholder="请输入appSecret" size="mini" style="width: 280px;margin-left: 5px;" />
    </p>


    <div style="display: flex;justify-content: space-between">
      <text-title :mainTitle="'人脸收费金额配置'" />
      <div class="operationBox">
        <a @click="changeFaceCharging" v-if="faceCharging">修改</a><a @click="cancelChangeFaceCharging" v-if="!faceCharging">取消</a><a @click="confirmChangeFaceCharging" v-if="!faceCharging">确定</a>
      </div>
    </div>
    <p class="faceConfig">
      <span>人脸收费金额</span>
      <el-input v-model="faceAmount" type="number" :disabled="faceCharging" placeholder="请输入收费金额" size="mini" style="width: 280px;margin-left: 5px;"  v-on:blur="faceAmountChange()">
        <template slot="append">元</template>
      </el-input>
    </p>

    <div style="display: flex;justify-content: space-between">
      <text-title :mainTitle="'小程序广告配置'" />
      <div class="operationBox">
        <a @click="changeAdCharging" v-if="adCharging">修改</a><a @click="cancelChangeAdCharging" v-if="!adCharging">取消</a><a @click="confirmChangeAdCharging" v-if="!adCharging">确定</a>
      </div>
    </div>
    <p class="faceConfig">
      <span style="display:inline-block;width: 84px;text-align:right;">小程序广告</span>
      <el-select :disabled="adCharging" v-model="adData.configValue" placeholder="请选择" size="mini" style="width: 280px;margin-left: 5px;">
        <el-option
          v-for="item in adList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </p>

    <div style="display: flex;justify-content: space-between">
      <text-title :mainTitle="'大华云睿配置'" />
      <div class="operationBox">
        <a @click="setVideoStore" v-if="!dhyrConfig">同步</a>
      </div>
    </div>
    <p class="faceConfig">
      <span style="display:inline-block;width: 84px;text-align:right;">门店ID</span>
      <el-input v-model="dhyrConfig" type="number" :disabled="true" placeholder="门店ID" size="mini" style="width: 280px;margin-left: 5px;" />
    </p>
  </div>
</template>

<script>
  import {api} from '../../api/Config'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import {nError, nSuccess} from '../../../utils/notice'
  import TextTitle from '../../../components/Text/TextTitle'
  import {errorHandler} from '../../../utils/errorHandler'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TextTitle,
      Breadcrumb},
    name: 'config-basic',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '配置中心',
          name: 'config-basic'
        }, {
          value: '基础配置'
        }],
        checkList: [],
        defaultCheckList: [],
        yqServiceState: true,

        serviceList: [
          { code: 'PE', name: '资源中心', servicesState: '0', servicesTime: '' },
          { code: 'PF', name: '智慧合约', servicesState: '0', servicesTime: '' },
          { code: 'PG', name: '智慧门禁', servicesState: '0', servicesTime: '' },
          { code: 'PC', name: '智慧停车', servicesState: '0', servicesTime: '' },
          { code: 'PD', name: '智慧用电', servicesState: '0', servicesTime: '' },
          { code: 'QA', name: '智慧用水', servicesState: '0', servicesTime: '' },
          { code: 'PB', name: '智慧梯控', servicesState: '0', servicesTime: '' },
          { code: 'PA', name: '智慧访客', servicesState: '0', servicesTime: '' },
          { code: 'PH', name: '智慧预约', servicesState: '0', servicesTime: '' },
          { code: 'PI', name: '智慧防疫', servicesState: '0', servicesTime: '' },
          { code: 'PJ', name: '智慧财务', servicesState: '0', servicesTime: '' },
          { code: 'PK', name: '智慧大脑', servicesState: '0', servicesTime: '' },
          { code: 'PL', name: '智慧报修', servicesState: '0', servicesTime: '' },
          { code: 'PM', name: '智慧招商', servicesState: '0', servicesTime: '' },
          { code: 'PP', name: '智慧文书', servicesState: '0', servicesTime: '' },
          { code: 'PN', name: '智慧凭证', servicesState: '0', servicesTime: '' },
          { code: 'PO', name: '智慧缴费', servicesState: '0', servicesTime: '' },
          { code: 'PQ', name: '智慧消息', servicesState: '0', servicesTime: '' },
          { code: 'PR', name: '严选服务', servicesState: '0', servicesTime: '' },
          { code: 'PS', name: '智慧活动', servicesState: '0', servicesTime: '' },
          { code: 'PT', name: '智慧消防', servicesState: '0', servicesTime: '' },
          { code: 'PU', name: '智慧监控', servicesState: '0', servicesTime: '' },
          { code: 'PV', name: '报警中心', servicesState: '0', servicesTime: '' },
          { code: 'PW', name: '智慧空调', servicesState: '0', servicesTime: '' },
          { code: 'PX', name: '智慧巡检', servicesState: '0', servicesTime: '' },
          { code: 'PY', name: '智慧巡更', servicesState: '0', servicesTime: '' },
          // { code: 'PZ', name: '企业大数据', servicesState: '0', servicesTime: '' },
          { code: 'QB', name: '园区数据', servicesState: '0', servicesTime: '' },
          { code: 'QC', name: '企业数据', servicesState: '0', servicesTime: '' },
          { code: 'QD', name: '智慧孵化', servicesState: '0', servicesTime: '' },
          { code: 'HQ', name: '惠企服务', servicesState: '0', servicesTime: '' },
        ],

        visitorServicesState: '0',
        payServicesState: '0',
        electricServicesState: '0',
        basicServicesState: '0',
        investmentLeasingState: '0',
        yqServicesState: '0',
        accessCtrlServicesState: '0',
        siteServicesState: '0',
        epidemicServicesState: '0',
        financeServicesState: '0',
        brainServicesState: '0',
        repairServicesState: '0',
        agentServicesState: '0',
        documentServicesState: '0',
        invoiceServicesState: '0',
        customPaymentServicesState: '0',
        messageServicesState: '0',
        valueAddServicesState: '0',
        activityServicesState: '0',
        fireControlServicesState: '0',
        monitorServicesState: '0',
        callPoliceServicesState: '0',
        airConditionerServicesState: '0',
        inspectionServicesState: '0',
        enterpriseBigDataServicesState: '0',
        keepWatchServicesState: '0',
        serverStateList: [{
          label: '未开通',
          value: '0'
        }, {
          label: '已开通',
          value: '1'
        }, {
          label: '试用',
          value: '2'
        }],
        yqCodeState: true,
        yqCodeArr: [{
          code: 'A',
          label: '智慧门禁'
        }, {
          code: 'B',
          label: '访客预约'
        }, {
          code: 'C',
          label: '智慧预约'
        }, {
          code: 'D',
          label: '停车缴费'
        }, {
          code: 'E',
          label: '录入人脸'
        }, {
          code: 'F',
          label: '推荐有礼'
        }, {
          code: 'G',
          label: '使用帮助'
        }, {
          code: 'H',
          label: '更多'
        }],
        yqCodeDefaultArr: [],
        faceCharging: true,
        faceAmount: '1.00',
        faceInfo: {},

        faceDataConfig: true,
        faceConfigList: {
          appId: '',
          appKey: '',
          appSecret: ''
        },
        defaultFaceConfigList: {
          appId: '',
          appKey: '',
          appSecret: ''
        },
        visitorTime: '',
        payTime: '',
        yqServicesTime: '',
        electricTime: '',
        basicServicesTime: '',
        investmentLeasingTime: '',
        accessCtrlServicesTime: '',
        siteServicesTime: '',
        epidemicServicesTime: '',
        financeServicesTime: '',
        brainServicesTime: '',
        repairServicesTime: '',
        agentServicesTime: '',
        documentServicesTime: '',
        invoiceServicesTime: '',
        customPaymentServicesTime: '',
        messageServicesTime: '',
        valueAddServicesTime: '',
        activityServicesTime: '',
        fireControlServicesTime: '',
        monitorServicesTime: '',
        callPoliceServicesTime: '',
        airConditionerServicesTime: '',
        inspectionServicesTime: '',
        enterpriseBigDataServicesTime: '',
        keepWatchServicesTime: '',
        adCharging: true,
        adState: false,
        adData: {
          configValue: '0'
        },

        adList: [
          {
            value: '0',
            label: '无'
          }, {
            value: '1',
            label: 'Banner广告'
          }, {
            value: '2',
            label: '视频广告'
          }
        ],

        dhyrConfig: '',

        pickerOptions: {
          shortcuts: [{
            text: '未来一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来一年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来三年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 3)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getYqServerConfig()
      // this.getYqFunctionCode()
      this.getFacePayConfig()
      this.getFaceConfig()
      this.getAdConfig()

      this.getVideoStore()
    },
    methods: {
      // 获取服务配置数据
      getYqServerConfig () {
        this.$axios.post(api.getYqServerConfig, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.map(v => {
                this.yqCodeDefaultArr.push(v)
                this.serviceList.map(service => {
                  if (service.code === v.configValue) {
                    service.servicesState = v.configStatus
                    if (v.serviceStartTime && v.serviceEndTime) {
                      service.servicesTime = [v.serviceStartTime, v.serviceEndTime]
                    }
                  }
                })
              })
            }
          })
          .catch(errorHandler('查询公寓服务状态失败'))
      },

      // 获取园区码小程序功能配置
      getYqFunctionCode () {
        this.$axios.post(api.getYqFunctionCode, {})
          .then(res => {
            let data = res.data.data
            let codeList = []
            if (data.configValue) {
              codeList = data.configValue.split(',')
            } else {
              codeList = []
            }
            if (codeList) {
              let codeArr = []
              codeList.map(val => {
                this.yqCodeArr.map(v => {
                  if (v.code === val && codeArr.indexOf(v.label) === -1) {
                    codeArr.push(v.label)
                  }
                })
              })
              this.checkList = codeArr
              this.defaultCheckList = codeArr
            } else {
              this.checkList = []
              this.defaultCheckList = []
            }
          })
          .catch(errorHandler('获取配置信息失败'))
      },

      // 获取人脸配置参数
      getFaceConfig () {
        this.$axios.post(`${api.getFaceConfig}`, {})
          .then(res => {
            let data = res.data.data
            this.faceConfigList = data
            this.defaultFaceConfigList = data
          })
          .catch(errorHandler('获取人脸配置参数失败'))
      },

      // 获取人脸金额配置
      getFacePayConfig () {
        this.$axios.post(`${api.getFacePayConfig}/J001`, {})
          .then(res => {
            let data = res.data.data
            this.faceInfo = data
            if (this.faceInfo.configValue) {
              this.faceAmount = this.faceInfo.configValue
            } else {
              this.faceAmount = '1.00'
            }
          })
          .catch(errorHandler('获取人脸金额失败'))
      },


      changeyqServiceState () {
        this.yqServiceState = false
      },
      cancelChangeyqServiceState () {
        this.yqServiceState = true
        this.getYqServerConfig()
      },
      confirmChangeyqServiceState () {
        this.$confirm('是否确认更改园区平台服务配置？')
          .then(() => {
            this.updateyqServiceCode()
          })
      },
      updateyqServiceCode () {
        this.yqCodeDefaultArr.map(v => {
          this.serviceList.map(service => {
            if (v.configValue === service.code) {
              v.configStatus = service.servicesState
              v.serviceStartTime = service.servicesTime[0]
              v.serviceEndTime = service.servicesTime[1]
            }
          })
        })
        this.$axios.post(api.updateyqServerConfig, this.yqCodeDefaultArr)
          .then(() => {
            nSuccess('修改成功')
            this.yqServiceState = true
            this.getYqServerConfig()
          })
          .catch(errorHandler('修改失败'))
      },


      changeSchoolCodeState () {
        this.yqCodeState = false
      },
      cancelChangeSchoolCodeState () {
        this.yqCodeState = true
        this.checkList = this.defaultCheckList
      },
      confirmChangeSchoolCodeState () {
        this.$confirm('是否确认更改校园码小程序功能配置？')
          .then(() => {
            this.updateyqCode()
          })
      },
      updateyqCode () {
        let configValueArr = []
        this.checkList.map(val => {
          this.yqCodeArr.map(v => {
            if (v.label === val && configValueArr.indexOf(v.code) === -1) {
              configValueArr.push(v.code)
            }
          })
        })
        let configValue = configValueArr.join(',')
        this.$axios.post(api.updateyqFunctionCode, {configValue})
          .then(() => {
            nSuccess('修改成功')
            this.yqCodeState = true
            this.getYqFunctionCode()
          })
          .catch(errorHandler('修改失败'))
      },

      changeFaceDataConfig () {
        this.faceDataConfig = false
      },

      cancelChangeFaceDataConfig () {
        this.faceDataConfig = true
        this.faceConfigList = this.defaultFaceConfigList
      },

      confirmChangeFaceDataConfig () {
        this.$confirm('是否确认更改人脸设备参数配置？')
          .then(() => {
            this.updateFaceDataConfig()
          })
      },

      updateFaceDataConfig () {
        this.$axios.post(api.updateFaceConfig, this.faceConfigList)
          .then(() => {
            nSuccess('修改成功')
            this.faceDataConfig = true
            this.getFaceConfig()
          })
          .catch(errorHandler('修改失败'))
      },


      changeFaceCharging () {
        this.faceCharging = false
      },
      cancelChangeFaceCharging () {
        this.faceCharging = true
        this.checkList = this.defaultCheckList
      },
      confirmChangeFaceCharging () {
        this.$confirm('是否确认更改人脸收费金额配置？')
          .then(() => {
            this.updateFaceCharging()
          })
      },
      updateFaceCharging () {
        this.faceInfo.configValue = this.faceAmount
        this.$axios.post(api.updateFacePayConfig, this.faceInfo)
          .then(() => {
            nSuccess('修改成功')
            this.faceCharging = true
            this.getFacePayConfig()
          })
          .catch(errorHandler('修改失败'))
      },
      faceAmountChange () {
        if (this.faceAmount) {
          if (parseFloat(this.faceAmount) > 1 || parseFloat(this.faceAmount) === 1.00) {
            this.faceAmount = parseFloat(this.faceAmount).toFixed(2)
          } else {
            nError('收费金额不能小于1元')
            this.faceAmount = '1.00'
          }
        } else {
          this.faceAmount = '1.00'
        }
      },

      // 获取广告配置
      getAdConfig () {
        this.$axios.post(`${api.getFacePayConfig}/G001`, {})
          .then(res => {
            let data = res.data.data
            this.adData = data
          })
          .catch(errorHandler('获取广告配置失败'))
      },
      changeAdCharging () {
        this.adCharging = false
      },
      cancelChangeAdCharging () {
        this.adCharging = true
        this.getAdConfig()
      },
      confirmChangeAdCharging () {
        this.$confirm('是否确认更改小程序广告配置？')
          .then(() => {
            this.updateAdCharging()
          })
      },
      updateAdCharging () {
        this.$axios.post(api.updateByCode, this.adData)
          .then(() => {
            nSuccess('修改成功')
            this.adCharging = true
            this.getAdConfig()
          })
          .catch(errorHandler('修改失败'))
      },

      // 大华云睿
      getVideoStore () {
        this.$axios.post(`${api.getVideoStore}`, {})
          .then(res => {
            let data = res.data.data
            this.dhyrConfig = data
          })
          .catch(errorHandler('获取配置失败'))
      },
      // 大华云睿
      setVideoStore () {
        this.$axios.post(`${api.setVideoStore}`, {})
          .then(res => {
            nSuccess('同步成功')
            this.getVideoStore()
          })
          .catch(errorHandler('同步失败'))
      },
    }
  }
</script>

<style scoped>
  .operationBox {
    margin: 20px 0 10px 0;
  }
  .operationBox a {
    font-size: 14px;
    float: right;
    margin-right: 30px;
    color: #00A0E6;
  }
  p {
    width: 94%;
    margin: 0 auto;
    line-height: 40px;
    text-align: left;
  }
  p>span>span {
    width: 70px;
    display: inline-block;
  }
  .server_box {

  }
  .server_change {
    width: 90px;
    margin: 0 5px;
  }

</style>

<style lang="less">
  .server_box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 32%;
    margin-right: 1%;
    .el-input--mini .el-input__inner {
      height: 28px !important;
    }
    .server_time {
      flex: 1;
      width: 200px !important;
    }
    .el-range-editor.is-disabled .el-range-separator {
      width: 20px!important;
      padding: 0;
    }
    .el-range-editor--mini .el-range-separator {
      width: 20px!important;
      padding: 0;
    }
  }
  .faceConfig {
    .el-input__inner {
      padding: 0 0 0 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/ConfigCenter/ConfigBasic/ConfigBasic.vue